import { Spin } from 'antd';
import React, { ReactElement } from 'react';

const Spinner = ({ height }: any): ReactElement => {
  return (
    <div className="fallback-loader" style={{ height: height || '100vh' }}>
      <Spin size="large" style={{ height: !height ? 'unset' : '100vh' }} />
    </div>
  );
};

export default Spinner;
